import { jsx as _jsx } from "react/jsx-runtime";
import { Markdown } from '../../markdown';
export function LinkDescription({ link }) {
    return _jsx(Markdown, { content: link.description });
}
